var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { TasksTableHeader, } from '../../../ActivityStreamDashboard/shared';
import { getStickyCss } from '../../utils/styles';
import { GradeModuleStream } from './GradeModuleStream';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-v5kqay" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"])));
var ActivitiesHeadingRow = styled(TasksTableHeader).withConfig({ displayName: "ActivitiesHeadingRow", componentId: "sc-1g4cbn2" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: flex-end;\n  width: 100%;\n  ", ";\n  z-index: 8;\n  padding-top: 16px;\n  padding-bottom: 0;\n  background: ", ";\n"], ["\n  align-items: flex-end;\n  width: 100%;\n  ", ";\n  z-index: 8;\n  padding-top: 16px;\n  padding-bottom: 0;\n  background: ", ";\n"])), function (_a) {
    var $isWeekInThePast = _a.$isWeekInThePast, $withFilter = _a.$withFilter;
    return getStickyCss({
        includeHeaderOffset: true,
        isWeekInThePast: $isWeekInThePast,
        withFilter: $withFilter,
    });
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue99;
});
var StreamsContent = function (_a) {
    var isWeekInThePast = _a.isWeekInThePast, studentActivityStream = _a.studentActivityStream, filterShowed = _a.filterShowed, _b = _a.filterActive, filterActive = _b === void 0 ? false : _b;
    var prevGradeAndModule = '';
    return (_jsxs(Container, { children: [_jsx(ActivitiesHeadingRow, { withoutLeftPadding: true, "$isWeekInThePast": isWeekInThePast, "$withFilter": filterShowed, isWeekly: true }, void 0), studentActivityStream.map(function (stream) {
                var grade = stream.grade, module = stream.module, cards = stream.cards;
                var visibleGradeAndModule = grade + ". " + module + "." === prevGradeAndModule
                    ? ''
                    : grade + ". " + module + ".";
                prevGradeAndModule = grade + ". " + module + ".";
                var firstCardPrefix = cards[0].cardNamePrefix;
                var isBeginNewModule = (firstCardPrefix === null || firstCardPrefix === void 0 ? void 0 : firstCardPrefix.slice(firstCardPrefix.length - 3)) === 'A.A';
                return (_jsx(GradeModuleStream, { stream: stream, filterActive: filterActive, gradeAndModule: visibleGradeAndModule, isBeginNewModule: isBeginNewModule }, grade + "-" + module + "-" + cards[0].cardId));
            })] }, void 0));
};
export { StreamsContent };
var templateObject_1, templateObject_2;
